import { getInputImageAsset } from 'Pods/ThreeDStudio/Shared/Utils/getInputImageAsset'

/**
 * Resolves the image input of an image-to-3d run for the store: a multi-view run
 * restores its labelled views into inputViewImages, a single-image run restores the
 * reference image. The two never mix, matching the separate uploaders.
 *
 * @param {Object} openedModel - Run object from the library
 * @returns {Object} modelSettings patch for the image input
 */
export const parseImageInput = ({ multiviewInput, inputAssets }) => {
  if (multiviewInput) {
    const inputViewImages = (inputAssets || [])
      .filter(asset => asset.assetType === 'image' && asset.viewType)
      .reduce((views, asset) => ({
        ...views,
        [asset.viewType]: { id: asset.assetId, url: asset.fileUrl },
      }), {})

    return { isMultiView: true, inputViewImages }
  }

  const { assetId: inputImage, fileUrl: inputImageUrl } = getInputImageAsset(inputAssets)

  return { inputImage, inputImageUrl }
}
